interface RecieptConfigurations {
  [key: string]: string;
}
